var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArnacaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7422 0.147178C20.4563 0.161262 24.1928 1.37444 27.3254 3.85967C34.7259 9.73088 35.9532 20.4733 30.0663 27.8541C24.1794 35.2349 13.4082 36.4589 6.00761 30.5877C2.8751 28.1025 0.849243 24.7447 0 21.1385C0.513526 26.0827 2.94186 30.8259 7.15085 34.1651C15.4571 40.7546 27.5468 39.3814 34.154 31.0973C40.7611 22.8132 39.3842 10.7558 31.0779 4.16633C26.869 0.827081 21.6894 -0.465487 16.7429 0.147178H16.7422Z",
    fill: "url(#paint0_linear_2019_11207)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2884 30.5886L24.0109 31.6902L24.2028 30.5404L25.2884 30.5886L25.8148 30.9076L25.7513 29.5986L25.2884 30.5886Z",
    fill: "url(#paint1_linear_2019_11207)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8148 30.9079L24.0109 31.6905L25.2884 30.5889L25.8148 30.9079Z",
    fill: "url(#paint2_linear_2019_11207)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7512 29.5986L24.2028 30.5404L25.2883 30.5886L25.7512 29.5986Z",
    fill: "url(#paint3_linear_2019_11207)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7208 35.1377L17.2778 35.5088L17.6611 36.8139L17.7208 35.1377Z",
    fill: "url(#paint4_linear_2019_11207)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7208 35.1377L18.2357 35.5447L17.6611 36.8139",
    fill: "url(#paint5_linear_2019_11207)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85852 30.9434L17.0545 36.7147L16.6834 34.9185L9.85852 30.9434Z",
    fill: "url(#paint6_linear_2019_11207)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0545 36.7147L11.8223 34.7509L9.85852 30.9434L12.6601 34.3555L17.0545 36.7147Z",
    fill: "url(#paint7_linear_2019_11207)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6834 34.9185L16.1088 34.0203L9.85852 30.9434L12.6601 34.3555L11.8223 34.7509L9.85852 30.9434L12.6601 34.3555L17.0545 36.7147L16.6834 34.9185Z",
    fill: "url(#paint8_linear_2019_11207)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0545 36.7147L9.85852 30.9434L16.6834 34.9185L17.0545 36.7147Z",
    fill: "url(#paint9_linear_2019_11207)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85852 30.9434L12.6601 34.3555L11.8223 34.7509L9.85852 30.9434Z",
    fill: "url(#paint10_linear_2019_11207)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0616 30.1564L21.1811 29.8572L22.4984 29.4502L23.4081 29.6537L22.9773 31.0667L21.5528 30.8747L21.0616 30.1564Z",
    fill: "url(#paint11_linear_2019_11207)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4984 29.4502L21.5527 30.8747L23.408 29.6537",
    fill: "url(#paint12_linear_2019_11207)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9773 31.0676L20.0557 32.9113L21.0616 30.1572L21.5528 30.8756L20.0557 32.9113L21.5528 30.8756L22.9773 31.0676Z",
    fill: "url(#paint13_linear_2019_11207)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5528 30.875L20.0557 32.9107L22.9773 31.067L21.5528 30.875Z",
    fill: "url(#paint14_linear_2019_11207)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2623 34.708L27.4994 36.8818V35.8976L29.2623 34.708Z",
    fill: "url(#paint15_linear_2019_11207)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4994 36.8815L21.8397 37.2301L27.4994 35.8973L26.4536 34.4824L29.2623 34.7077L27.4994 35.8973V36.8815Z",
    fill: "url(#paint16_linear_2019_11207)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8397 37.2301L26.4536 34.4824L27.4994 35.8973L21.8397 37.2301Z",
    fill: "url(#paint17_linear_2019_11207)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2498 20.3018L15.1542 21.2596L15.5137 21.8463L15.8969 21.0086L15.2498 20.3018Z",
    fill: "url(#paint18_linear_2019_11207)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2499 20.3018L15.4181 21.1877L15.897 21.0086",
    fill: "url(#paint19_linear_2019_11207)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1542 21.2594L15.418 21.1875L15.5137 21.8462",
    fill: "url(#paint20_linear_2019_11207)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3749 27.0199L14.5347 24.9238L15.5465 26.5005L14.8641 26.4312L14.3749 27.0199Z",
    fill: "url(#paint21_linear_2019_11207)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5347 24.9238L14.8641 26.4312L15.4932 28.1645L15.5465 26.5005L15.4932 28.1645L14.3749 27.0199L14.8641 26.4312L15.5465 26.5005",
    fill: "url(#paint22_linear_2019_11207)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5466 26.5L14.8641 26.4307L15.4933 28.164",
    fill: "url(#paint23_linear_2019_11207)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9261 14.373L16.4266 15.9112L16.8478 16.9057L17.7067 15.8573L16.9261 14.373Z",
    fill: "url(#paint24_linear_2019_11207)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.926 14.373L17.1424 15.4407L17.7067 15.8573L16.926 14.373Z",
    fill: "url(#paint25_linear_2019_11207)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4266 15.911L17.1424 15.4404L16.8478 16.9054L16.4266 15.911Z",
    fill: "url(#paint26_linear_2019_11207)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5316 26.5986L21.4481 27.7003L21.771 28.1188L22.0464 27.4249L21.5316 26.5986Z",
    fill: "url(#paint27_linear_2019_11207)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0464 27.4249L21.5316 26.5986L21.7235 27.5565L22.0464 27.4249L21.7235 27.5565L21.4481 27.7003L21.7235 27.5565L21.771 28.1188L21.4481 27.7003L21.5316 26.5986",
    fill: "url(#paint28_linear_2019_11207)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.771 28.1188L22.0464 27.4248L21.7235 27.5564L21.771 28.1188Z",
    fill: "url(#paint29_linear_2019_11207)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4481 27.7005L21.7235 27.5566L21.771 28.119",
    fill: "url(#paint30_linear_2019_11207)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5316 26.5986L21.7236 27.5565L22.0465 27.4249",
    fill: "url(#paint31_linear_2019_11207)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7518 22.1865L20.1828 24.8546L19.7822 25.2918L19.5319 22.7033L20.0942 22.9755L21.7518 22.1865Z",
    fill: "url(#paint32_linear_2019_11207)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0942 22.9747L19.9838 21.6933L19.5319 22.7024L20.0942 22.9747L21.7518 22.1857L20.7523 20.8105",
    fill: "url(#paint33_linear_2019_11207)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7518 22.1857L20.1828 24.8537L19.7822 25.2909L20.0942 22.9747L20.7523 20.8105L19.9838 21.6933L20.0942 22.9747",
    fill: "url(#paint34_linear_2019_11207)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1828 24.8537L20.0942 22.9746L19.7822 25.2909L20.1828 24.8537Z",
    fill: "url(#paint35_linear_2019_11207)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2645 20.3604L24.9579 21.175L25.119 21.3028L25.033 20.438L24.8648 20.5517L24.2645 20.3604Z",
    fill: "url(#paint36_linear_2019_11207)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8648 20.5512L24.8179 20.1236L25.033 20.4376L24.8648 20.5512L24.2645 20.3599L24.5059 19.8643",
    fill: "url(#paint37_linear_2019_11207)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2645 20.3599L24.9579 21.1745L25.119 21.3023L24.8648 20.5512L24.5059 19.8643L24.8179 20.1236L24.8648 20.5512",
    fill: "url(#paint38_linear_2019_11207)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.958 21.1751L24.8649 20.5518L25.1191 21.3029L24.958 21.1751Z",
    fill: "url(#paint39_linear_2019_11207)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55417 22.3105L8.7074 22.9891L9.29417 22.8081L9.55417 22.3105Z",
    fill: "url(#paint40_linear_2019_11207)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29551 22.8048L9.48361 23.0654L10.0344 23.8313L9.80075 25.0806L9.51378 25.8048L9.31348 25.053L8.33704 24.2005L8.70874 22.9859L9.55551 22.3066L9.29551 22.8048Z",
    fill: "url(#paint41_linear_2019_11207)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3141 25.0524L8.33765 24.1999L8.90259 25.2501L9.51375 25.8041L9.3141 25.0524L10.035 23.8307L9.55548 22.3066L9.3141 25.0524Z",
    fill: "url(#paint42_linear_2019_11207)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51375 25.8045L8.90259 25.2505L8.33765 24.2002L9.3141 25.0527L9.51375 25.8045Z",
    fill: "url(#paint43_linear_2019_11207)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M10.035 23.8311L9.31409 25.0527L9.51374 25.8045L9.80071 25.081L10.035 23.8311Z",
    fill: "url(#paint44_linear_2019_11207)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70874 22.9859L9.29551 22.8048L9.55551 22.3066L8.70874 22.9859Z",
    fill: "url(#paint45_linear_2019_11207)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55553 22.3066L9.29553 22.8048L9.48813 23.0751L9.31415 25.0524L10.0351 23.8307L9.55553 22.3066Z",
    fill: "url(#paint46_linear_2019_11207)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48813 23.0751L9.55553 22.3066L9.29553 22.8048",
    fill: "url(#paint47_linear_2019_11207)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21251 29.7313L8.15344 29.0547L8.51167 28.6631L8.21251 29.7313Z",
    fill: "url(#paint48_linear_2019_11207)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63025 28.7909L7.95252 28.1797L8.51169 28.6631L7.95252 28.1797L8.15346 29.0547L7.63025 28.7909L8.21252 29.7313L8.15346 29.0547L8.51169 28.6631L8.15346 29.0547L7.95252 28.1797L8.15346 29.0547L8.51169 28.6631L7.95252 28.1797L7.63025 28.7909Z",
    fill: "url(#paint49_linear_2019_11207)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15346 29.0547L7.95252 28.1797L7.63025 28.7909L8.15346 29.0547L8.51169 28.6631L8.15346 29.0547Z",
    fill: "url(#paint50_linear_2019_11207)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0636 16.8418L21.1239 17.4883L21.6863 17.7515L22.1293 17.7996L21.6626 17.0934L21.0636 16.8418Z",
    fill: "url(#paint51_linear_2019_11207)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4815 17.218L21.8783 16.8174L21.4815 17.218L21.0636 16.8411L21.8783 16.8174L22.1293 17.799",
    fill: "url(#paint52_linear_2019_11207)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4815 17.218L21.8783 16.8174L21.0636 16.8411L21.4815 17.218L21.1239 17.4876L21.6863 17.7508",
    fill: "url(#paint53_linear_2019_11207)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6646 17.583L11.9815 18.3733L11.9456 18.96L12.6042 18.3373L12.2691 18.3733L11.9456 18.96L12.2691 18.3733H11.9815H12.2691L12.6646 17.583Z",
    fill: "url(#paint54_linear_2019_11207)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6042 18.3379L12.2691 18.3738L11.9456 18.9606L12.6042 18.3379Z",
    fill: "url(#paint55_linear_2019_11207)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6042 18.3373L12.6646 17.583L12.2691 18.3733H11.9815L11.9456 18.96L12.2691 18.3733L12.6042 18.3373Z",
    fill: "url(#paint56_linear_2019_11207)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6646 17.5832L11.9822 18.3735H12.2698C12.2698 18.3735 12.6646 17.5684 12.6646 17.5832Z",
    fill: "url(#paint57_linear_2019_11207)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0726 34.8553L9.33089 34.4053L9.1261 34.4175L11.0726 34.8553Z",
    fill: "url(#paint58_linear_2019_11207)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97841 33.2916L9.10295 32.3428L8.74023 33.2441L8.97841 33.2916L9.33086 34.4061L9.12606 34.4183L8.74023 33.2441",
    fill: "url(#paint59_linear_2019_11207)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33086 34.4061L9.10295 32.3428L8.97841 33.2916L8.74023 33.2441L9.12606 34.4183L11.0725 34.8561L10.6764 34.3271L9.7154 32.7126L9.10295 32.3428L10.6764 34.3271L9.33086 34.4061L11.0725 34.8561L9.33086 34.4061Z",
    fill: "url(#paint60_linear_2019_11207)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33086 34.4052L8.97841 33.2907L8.74023 33.2432L9.12606 34.4173L9.33086 34.4052Z",
    fill: "url(#paint61_linear_2019_11207)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97839 33.2916L9.33084 34.4061L10.6764 34.3271L9.10294 32.3428L8.97839 33.2916Z",
    fill: "url(#paint62_linear_2019_11207)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97841 33.2907L9.33086 34.4052L9.12606 34.4173L8.74023 33.2432L8.97841 33.2907Z",
    fill: "url(#paint63_linear_2019_11207)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6765 34.3262L10.5885 34.7294L11.0726 34.8552",
    fill: "url(#paint64_linear_2019_11207)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16.356 31.905L17.6373 30.085L15.5779 31.8331L16.356 31.905L19.0381 31.9294L19.6846 31.6777L17.6373 30.085L15.5779 31.8331L16.356 31.905L17.7092 35.0064L15.5779 31.8331L17.6373 30.085L16.356 31.905Z",
    fill: "url(#paint65_linear_2019_11207)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7092 35.0064L16.356 31.905L19.0381 31.9294L16.356 31.905L17.6373 30.085L19.0381 31.9294L17.7092 35.0064L19.6846 31.6777L17.7092 35.0064Z",
    fill: "url(#paint66_linear_2019_11207)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7092 35.0057L16.356 31.9043L19.0381 31.9287L17.7092 35.0057Z",
    fill: "url(#paint67_linear_2019_11207)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6373 30.085L19.0381 31.9294L19.6846 31.6777L17.6373 30.085Z",
    fill: "url(#paint68_linear_2019_11207)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M16.356 31.905L17.6373 30.085L15.5779 31.8331L17.6373 30.085L15.5779 31.8331L16.356 31.905L17.6373 30.085L19.0381 31.9294L19.6846 31.6777L17.7092 35.0064L19.0381 31.9294L16.356 31.905Z",
    fill: "url(#paint69_linear_2019_11207)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5779 31.832L16.356 31.9039L17.7092 35.0053L15.5779 31.832Z",
    fill: "url(#paint70_linear_2019_11207)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6373 30.085L16.356 31.905L15.5779 31.8331L17.6373 30.085Z",
    fill: "url(#paint71_linear_2019_11207)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2336 30.8766L12.4386 29.9541L12.8899 31.4987L14.2336 30.8766Z",
    fill: "url(#paint72_linear_2019_11207)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7966 29.3428L12.4784 31.4793L12.8899 31.4992L12.4386 29.9546L11.7966 29.3428Z",
    fill: "url(#paint73_linear_2019_11207)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4386 29.9546L14.2336 30.8771L14.3742 30.6165L11.7966 29.3428L12.4386 29.9546Z",
    fill: "url(#paint74_linear_2019_11207)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8899 31.5L15.0463 32.8443L14.2336 30.8779L12.8899 31.5Z",
    fill: "url(#paint75_linear_2019_11207)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5573 33.3353L14.3742 30.6172L15.5573 33.3353L12.4784 31.48L12.8899 31.4999L15.0463 32.8442L15.5573 33.3353L15.0463 32.8442L15.5573 33.3353Z",
    fill: "url(#paint76_linear_2019_11207)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7966 29.3428L12.4784 31.4793L12.8899 31.4992L12.4386 29.9546L11.7966 29.3428Z",
    fill: "url(#paint77_linear_2019_11207)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3742 30.6172L14.2336 30.8778L15.0464 32.8442L15.5574 33.3353L14.3742 30.6172Z",
    fill: "url(#paint78_linear_2019_11207)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2578 23.3926L26.3079 28.0758L27.8223 26.2899L27.8396 26.2699L27.3569 25.6607L27.6156 25.0617L27.2047 24.1771L26.4568 23.6539L26.2578 23.3926Z",
    fill: "url(#paint79_linear_2019_11207)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4568 23.6543L27.3568 25.6611L27.2047 24.1775",
    fill: "url(#paint80_linear_2019_11207)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6156 25.0615L27.7279 25.3851L27.8396 26.2697L27.3569 25.6605L26.3079 28.0756L27.8396 26.2697L27.6156 25.0615Z",
    fill: "url(#paint81_linear_2019_11207)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3569 25.6605L27.6157 25.0615L27.8397 26.2697",
    fill: "url(#paint82_linear_2019_11207)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2578 23.3926L26.7746 25.7467L26.3079 28.0758L26.2578 23.3926Z",
    fill: "url(#paint83_linear_2019_11207)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7746 25.7467L26.2764 25.5843L26.2578 23.3926L26.7746 25.7467Z",
    fill: "url(#paint84_linear_2019_11207)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4432 30.79L26.2887 33.8388L28.101 33.3926L28.1215 33.3875L28.0939 32.7686L28.5408 32.5022L28.6884 31.7389L28.4496 31.052L28.4432 30.79Z",
    fill: "url(#paint85_linear_2019_11207)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4497 31.0518L28.094 32.7684L28.6885 31.7387",
    fill: "url(#paint86_linear_2019_11207)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5408 32.502L28.4618 32.7632L28.1215 33.3872L28.0939 32.7684L26.2887 33.8385L28.1215 33.3872L28.5408 32.502Z",
    fill: "url(#paint87_linear_2019_11207)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M28.094 32.7684L28.5408 32.502L28.1216 33.3872",
    fill: "url(#paint88_linear_2019_11207)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4432 30.79L27.6779 32.5523L26.2887 33.8388L28.4432 30.79Z",
    fill: "url(#paint89_linear_2019_11207)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6779 32.5523L27.4314 32.2152L28.4432 30.79L27.6779 32.5523Z",
    fill: "url(#paint90_linear_2019_11207)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0988 37.6885L15.6614 38.3112L14.9912 39.9996L16.1487 38.957L17.0988 37.6885Z",
    fill: "url(#paint91_linear_2019_11207)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1487 38.957L17.0988 37.6885L15.6614 38.3112L16.1487 38.957L14.9912 40.0003L16.6912 39.2819",
    fill: "url(#paint92_linear_2019_11207)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6912 39.2816L16.1487 38.9567L17.0988 37.6895L16.6912 39.2816L16.1487 38.9567L16.6912 39.2816Z",
    fill: "url(#paint93_linear_2019_11207)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8109 38.3223L21.5528 38.6933L21.409 39.0888L18.9066 38.7055L18.8109 38.3223Z",
    fill: "url(#paint94_linear_2019_11207)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7203 38.0107L21.5528 38.6932L18.8109 38.3221L17.7927 38.0589L21.7203 38.0107Z",
    fill: "url(#paint95_linear_2019_11207)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9066 38.7052L18.8109 38.3219L21.5528 38.693L21.409 39.0884L21.5528 38.693L24.2228 38.1666L21.409 39.0884L18.9066 38.7052L17.7927 38.0587L18.8109 38.3219L17.7927 38.0587L22.2949 37.3281L21.7203 38.0105L21.5528 38.693L21.7203 38.0105L24.2228 38.1666L22.2949 37.3281L21.7203 38.0105L17.7927 38.0587",
    fill: "url(#paint96_linear_2019_11207)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2227 38.1668L21.7203 38.0107L21.5527 38.6932L24.2227 38.1668Z",
    fill: "url(#paint97_linear_2019_11207)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7203 38.0105L22.2949 37.3281L17.7927 38.0587L21.7203 38.0105Z",
    fill: "url(#paint98_linear_2019_11207)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7466 38.2757L17.0269 37.3891L11.8301 37.3776L11.4109 35.4619L8.56177 36.1681L11.8301 37.3776L11.7466 38.2757L8.56177 36.1681L11.4109 35.4619L15.1112 36.204L17.0269 37.3891L11.7466 38.2757L17.0269 37.3891L11.8301 37.3776L11.4109 35.4619L8.56177 36.1681L11.7466 38.2757L11.8301 37.3776L8.56177 36.1681",
    fill: "url(#paint99_linear_2019_11207)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0269 37.3885L11.7466 38.2751L11.83 37.377L17.0269 37.3885Z",
    fill: "url(#paint100_linear_2019_11207)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4109 35.4619L11.8301 37.3776L8.56177 36.1681L11.4109 35.4619Z",
    fill: "url(#paint101_linear_2019_11207)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1113 36.204L11.4109 35.4619L11.8301 37.3776",
    fill: "url(#paint102_linear_2019_11207)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6288 33.501L24.9939 33.7732L24.5208 33.5466L26.6951 31.5449",
    fill: "url(#paint103_linear_2019_11207)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3853 36.4317L23.4871 32.7075L26.6951 31.5449L25.5998 34.2939L25.6287 33.501L26.6951 31.5449L24.5207 33.5466L23.4871 32.7075L26.6951 31.5449L24.5207 33.5466L23.4871 32.7075",
    fill: "url(#paint104_linear_2019_11207)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3853 36.4321L23.8415 35.6463L23.2733 35.5809L23.8415 35.6463L25.5998 34.2943L24.9938 33.7737L23.2733 35.5809L21.3853 36.4321L23.4871 32.708L24.5207 33.5471L21.3853 36.4321Z",
    fill: "url(#paint105_linear_2019_11207)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6288 33.502L24.9939 33.7742L25.5999 34.2948L25.6288 33.502Z",
    fill: "url(#paint106_linear_2019_11207)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2733 35.5807L24.9938 33.7735L24.5207 33.5469L21.3853 36.432L23.2733 35.5807Z",
    fill: "url(#paint107_linear_2019_11207)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3335 34.2238L21.8956 32.5957L21.5605 34.799L19.3335 34.2238Z",
    fill: "url(#paint108_linear_2019_11207)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3335 34.2238L18.0161 37.026L20.2553 36.3911L21.5605 34.799L22.135 34.7508L21.8956 32.5957L19.3335 34.2238Z",
    fill: "url(#paint109_linear_2019_11207)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6624 36.5219L20.2553 36.3902L21.5605 34.7981L22.135 34.75L20.6624 36.5219L18.0161 37.0252L20.2553 36.3902L20.6624 36.5219Z",
    fill: "url(#paint110_linear_2019_11207)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5605 34.799L19.3335 34.2238L21.8956 32.5957L21.5605 34.799Z",
    fill: "url(#paint111_linear_2019_11207)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6624 36.5222L20.2553 36.3906L18.0161 37.0256L20.6624 36.5222Z",
    fill: "url(#paint112_linear_2019_11207)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2019_11207",
    x1: 9.60945,
    y1: 4.81674,
    x2: 29.584,
    y2: 35.2275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2019_11207",
    x1: 24.0109,
    y1: 30.6444,
    x2: 25.8148,
    y2: 30.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2019_11207",
    x1: 24.0109,
    y1: 31.1397,
    x2: 25.8148,
    y2: 31.1397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2019_11207",
    x1: 24.2028,
    y1: 30.0936,
    x2: 25.7512,
    y2: 30.0936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2019_11207",
    x1: 17.2778,
    y1: 35.9761,
    x2: 17.7208,
    y2: 35.9761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2019_11207",
    x1: 17.6611,
    y1: 35.9761,
    x2: 18.2357,
    y2: 35.9761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2019_11207",
    x1: 9.85852,
    y1: 33.829,
    x2: 17.0545,
    y2: 33.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2019_11207",
    x1: 13.4568,
    y1: 36.7147,
    x2: 13.4568,
    y2: 30.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2019_11207",
    x1: 9.85852,
    y1: 33.829,
    x2: 17.0545,
    y2: 33.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2019_11207",
    x1: 9.85852,
    y1: 33.829,
    x2: 17.0545,
    y2: 33.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2019_11207",
    x1: 9.85852,
    y1: 32.8468,
    x2: 12.6601,
    y2: 32.8468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2019_11207",
    x1: 21.0616,
    y1: 30.2585,
    x2: 23.4081,
    y2: 30.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2019_11207",
    x1: 21.5527,
    y1: 30.1628,
    x2: 23.408,
    y2: 30.1628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2019_11207",
    x1: 20.0557,
    y1: 31.5343,
    x2: 22.9773,
    y2: 31.5343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2019_11207",
    x1: 20.0557,
    y1: 31.8932,
    x2: 22.9773,
    y2: 31.8932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2019_11207",
    x1: 27.4994,
    y1: 35.7949,
    x2: 29.2623,
    y2: 35.7949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2019_11207",
    x1: 21.8397,
    y1: 35.8562,
    x2: 29.2623,
    y2: 35.8562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2019_11207",
    x1: 21.8397,
    y1: 35.8562,
    x2: 27.4994,
    y2: 35.8562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2019_11207",
    x1: 15.1542,
    y1: 21.074,
    x2: 15.8969,
    y2: 21.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2019_11207",
    x1: 15.2499,
    y1: 20.7447,
    x2: 15.897,
    y2: 20.7447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2019_11207",
    x1: 15.1542,
    y1: 21.5168,
    x2: 15.5137,
    y2: 21.5168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2019_11207",
    x1: 14.9792,
    y1: 27.008,
    x2: 14.9712,
    y2: 24.9126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2019_11207",
    x1: 14.9836,
    y1: 28.1572,
    x2: 14.9712,
    y2: 24.9126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2019_11207",
    x1: 15.2289,
    y1: 28.1557,
    x2: 15.2223,
    y2: 26.4198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2019_11207",
    x1: 16.3587,
    y1: 15.8974,
    x2: 17.4659,
    y2: 15.3543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2019_11207",
    x1: 17.0521,
    y1: 15.244,
    x2: 17.342,
    y2: 15.1018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2019_11207",
    x1: 16.5908,
    y1: 16.3704,
    x2: 17.4081,
    y2: 15.9694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2019_11207",
    x1: 21.4481,
    y1: 27.3587,
    x2: 22.0464,
    y2: 27.3587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2019_11207",
    x1: 21.4481,
    y1: 27.3587,
    x2: 22.0464,
    y2: 27.3587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2019_11207",
    x1: 21.7235,
    y1: 27.7715,
    x2: 22.0464,
    y2: 27.7715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2019_11207",
    x1: 21.6099,
    y1: 28.119,
    x2: 21.6099,
    y2: 27.5566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2019_11207",
    x1: 21.5316,
    y1: 27.0775,
    x2: 22.0465,
    y2: 27.0775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2019_11207",
    x1: 21.482,
    y1: 21.9247,
    x2: 19.0639,
    y2: 24.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2019_11207",
    x1: 21.3635,
    y1: 21.3367,
    x2: 19.8816,
    y2: 22.9947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2019_11207",
    x1: 21.5904,
    y1: 21.5394,
    x2: 18.9333,
    y2: 24.5124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2019_11207",
    x1: 20.5774,
    y1: 23.3867,
    x2: 19.2879,
    y2: 24.8293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2019_11207",
    x1: 23.3726,
    y1: 21.2207,
    x2: 24.3573,
    y2: 22.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2019_11207",
    x1: 23.3731,
    y1: 21.0204,
    x2: 23.9767,
    y2: 21.5097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2019_11207",
    x1: 23.3109,
    y1: 21.0972,
    x2: 24.3931,
    y2: 21.9744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2019_11207",
    x1: 23.7707,
    y1: 21.669,
    x2: 24.296,
    y2: 22.0948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2019_11207",
    x1: 8.89675,
    y1: 22.5589,
    x2: 9.42641,
    y2: 22.7517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2019_11207",
    x1: 8.49193,
    y1: 23.6706,
    x2: 10.1298,
    y2: 24.2667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2019_11207",
    x1: 8.55485,
    y1: 23.6928,
    x2: 10.1089,
    y2: 24.2584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2019_11207",
    x1: 8.17939,
    y1: 24.7248,
    x2: 9.73339,
    y2: 25.2904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2019_11207",
    x1: 9.47385,
    y1: 24.7027,
    x2: 9.91303,
    y2: 24.8625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2019_11207",
    x1: 8.89791,
    y1: 22.5552,
    x2: 9.42757,
    y2: 22.7479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2019_11207",
    x1: 9.06098,
    y1: 23.5375,
    x2: 10.0443,
    y2: 23.8954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2019_11207",
    x1: 9.3888,
    y1: 22.6368,
    x2: 9.64579,
    y2: 22.7304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2019_11207",
    x1: 8.6845,
    y1: 28.7805,
    x2: 7.99525,
    y2: 29.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2019_11207",
    x1: 8.42956,
    y1: 28.5144,
    x2: 7.74032,
    y2: 29.1749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2019_11207",
    x1: 8.24655,
    y1: 28.3235,
    x2: 7.72326,
    y2: 28.8249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2019_11207",
    x1: 21.0636,
    y1: 17.3207,
    x2: 22.1293,
    y2: 17.3207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2019_11207",
    x1: 21.0636,
    y1: 17.3079,
    x2: 22.1293,
    y2: 17.3079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2019_11207",
    x1: 21.0636,
    y1: 17.2841,
    x2: 21.8783,
    y2: 17.2841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2019_11207",
    x1: 11.9456,
    y1: 18.2712,
    x2: 12.6646,
    y2: 18.2712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2019_11207",
    x1: 11.9456,
    y1: 18.6492,
    x2: 12.6042,
    y2: 18.6492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2019_11207",
    x1: 11.9456,
    y1: 18.2712,
    x2: 12.6646,
    y2: 18.2712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2019_11207",
    x1: 11.9815,
    y1: 17.978,
    x2: 12.6646,
    y2: 17.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2019_11207",
    x1: 9.21473,
    y1: 34.7803,
    x2: 11.0407,
    y2: 34.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2019_11207",
    x1: 8.80133,
    y1: 33.4417,
    x2: 9.29806,
    y2: 33.3605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2019_11207",
    x1: 8.85982,
    y1: 33.7996,
    x2: 10.8752,
    y2: 33.4703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2019_11207",
    x1: 8.86842,
    y1: 33.8513,
    x2: 9.2587,
    y2: 33.7875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2019_11207",
    x1: 9.03742,
    y1: 33.4733,
    x2: 10.5263,
    y2: 33.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2019_11207",
    x1: 8.86842,
    y1: 33.8513,
    x2: 9.2587,
    y2: 33.7875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2019_11207",
    x1: 10.6024,
    y1: 34.6341,
    x2: 11.0535,
    y2: 34.5604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2019_11207",
    x1: 15.5779,
    y1: 32.5457,
    x2: 19.6846,
    y2: 32.5457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2019_11207",
    x1: 16.356,
    y1: 32.5457,
    x2: 19.6846,
    y2: 32.5457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2019_11207",
    x1: 16.356,
    y1: 33.4553,
    x2: 19.0381,
    y2: 33.4553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2019_11207",
    x1: 17.6373,
    y1: 31.0075,
    x2: 19.6846,
    y2: 31.0075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2019_11207",
    x1: 15.5779,
    y1: 32.5457,
    x2: 19.6846,
    y2: 32.5457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2019_11207",
    x1: 15.5779,
    y1: 33.419,
    x2: 17.7092,
    y2: 33.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2019_11207",
    x1: 15.5779,
    y1: 30.9953,
    x2: 17.6373,
    y2: 30.9953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2019_11207",
    x1: 12.4386,
    y1: 30.7264,
    x2: 14.2336,
    y2: 30.7264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2019_11207",
    x1: 11.7966,
    y1: 30.4213,
    x2: 12.8899,
    y2: 30.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2019_11207",
    x1: 11.7966,
    y1: 30.11,
    x2: 14.3742,
    y2: 30.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2019_11207",
    x1: 12.8899,
    y1: 31.8608,
    x2: 15.0463,
    y2: 31.8608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2019_11207",
    x1: 12.4784,
    y1: 31.9763,
    x2: 15.5573,
    y2: 31.9763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2019_11207",
    x1: 11.7966,
    y1: 30.4213,
    x2: 12.8899,
    y2: 30.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2019_11207",
    x1: 14.2336,
    y1: 31.9763,
    x2: 15.5574,
    y2: 31.9763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2019_11207",
    x1: 26.2578,
    y1: 25.7339,
    x2: 27.8396,
    y2: 25.7339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2019_11207",
    x1: 26.4568,
    y1: 24.6577,
    x2: 27.3568,
    y2: 24.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2019_11207",
    x1: 26.3079,
    y1: 26.5683,
    x2: 27.8396,
    y2: 26.5683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2019_11207",
    x1: 27.3569,
    y1: 25.6656,
    x2: 27.8397,
    y2: 25.6656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2019_11207",
    x1: 26.2578,
    y1: 25.7339,
    x2: 26.7746,
    y2: 25.7339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2019_11207",
    x1: 26.2578,
    y1: 24.5693,
    x2: 26.7746,
    y2: 24.5693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2019_11207",
    x1: 27.3243,
    y1: 32.2941,
    x2: 28.3462,
    y2: 33.0327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2019_11207",
    x1: 27.9559,
    y1: 31.6921,
    x2: 28.537,
    y2: 32.1122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2019_11207",
    x1: 26.9666,
    y1: 32.8567,
    x2: 27.9562,
    y2: 33.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2019_11207",
    x1: 28.0666,
    y1: 32.763,
    x2: 28.3782,
    y2: 32.9883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2019_11207",
    x1: 27.3243,
    y1: 32.2941,
    x2: 27.6584,
    y2: 32.5356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2019_11207",
    x1: 27.8677,
    y1: 31.5423,
    x2: 28.2018,
    y2: 31.7837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2019_11207",
    x1: 14.9912,
    y1: 38.844,
    x2: 17.0988,
    y2: 38.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2019_11207",
    x1: 14.9912,
    y1: 38.8447,
    x2: 17.0988,
    y2: 38.8447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2019_11207",
    x1: 16.1487,
    y1: 38.4855,
    x2: 17.0988,
    y2: 38.4855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2019_11207",
    x1: 18.8109,
    y1: 38.7055,
    x2: 21.5528,
    y2: 38.7055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2019_11207",
    x1: 17.7927,
    y1: 38.3523,
    x2: 21.7203,
    y2: 38.3523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2019_11207",
    x1: 17.7927,
    y1: 38.2083,
    x2: 24.2228,
    y2: 38.2083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2019_11207",
    x1: 21.5527,
    y1: 38.3523,
    x2: 24.2227,
    y2: 38.3523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2019_11207",
    x1: 17.7927,
    y1: 37.6934,
    x2: 22.2949,
    y2: 37.6934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2019_11207",
    x1: 8.56177,
    y1: 36.8685,
    x2: 17.0269,
    y2: 36.8685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2019_11207",
    x1: 11.7466,
    y1: 37.8257,
    x2: 17.0269,
    y2: 37.8257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2019_11207",
    x1: 8.56177,
    y1: 36.4198,
    x2: 11.8301,
    y2: 36.4198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2019_11207",
    x1: 11.4109,
    y1: 36.4198,
    x2: 15.1113,
    y2: 36.4198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2019_11207",
    x1: 24.4287,
    y1: 32.8878,
    x2: 26.8634,
    y2: 32.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2019_11207",
    x1: 21.0821,
    y1: 34.4671,
    x2: 27.0271,
    y2: 33.5042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2019_11207",
    x1: 21.1329,
    y1: 34.7806,
    x2: 25.5771,
    y2: 34.0608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2019_11207",
    x1: 25.044,
    y1: 33.9896,
    x2: 25.7056,
    y2: 33.8824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2019_11207",
    x1: 21.2123,
    y1: 35.2709,
    x2: 25.1483,
    y2: 34.6334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2019_11207",
    x1: 19.3335,
    y1: 33.6973,
    x2: 21.8956,
    y2: 33.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2019_11207",
    x1: 18.0161,
    y1: 34.8105,
    x2: 22.135,
    y2: 34.8105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2019_11207",
    x1: 18.0161,
    y1: 35.8876,
    x2: 22.135,
    y2: 35.8876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2019_11207",
    x1: 19.3335,
    y1: 33.6973,
    x2: 21.8956,
    y2: 33.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2019_11207",
    x1: 18.0161,
    y1: 36.7078,
    x2: 20.6624,
    y2: 36.7078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArnacaIcon);
export default __webpack_public_path__ + "static/media/arnaca_icon.ad8383859341ec817226df44c0abb955.svg";
export { ForwardRef as ReactComponent };